import { render, staticRenderFns } from "./HeaderBase.vue?vue&type=template&id=c07830bc&"
import script from "./HeaderBase.vue?vue&type=script&lang=js&"
export * from "./HeaderBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports